import { closeForwardList, openForwardList } from '$logic/router'
import { openRoom } from '$logic/opened-room'
import { sendNewMessage, sendTextMessage } from '$logic/message'
import { getRoom, getRoomPermissions } from '$logic/room'
import { showNoPermissoinToSendMessageSnackbar } from '$comp/snackbars'
import { isDesktopSize } from '$func/environmentInfo.js'
import { showForwardMenuModal } from '$comp/modals/forward-menu'

const SHARED_TARGET_DB_NAME = 'shareTarget'
const SHARED_TARGET_DB_VERSION = 2

async function sendSharedMessage({
  files,
  link,
  text,
  title,
}: {
  files: File[]
  text: string
  link: string
  title: string
}) {
  openForwardList(
    async (roomIds, caption) => {
      const room = await getRoom(roomIds[0])
      if (files && files.length) {
        if (files.length > 1) {
          // eslint-disable-next-line no-restricted-syntax
          for (const file of files)
            sendNewMessage(file, null, null, roomIds[0], room?.type)
          if (caption) sendTextMessage(caption, null, roomIds[0], room?.type)
        } else {
          sendNewMessage(files[0], text, null, roomIds[0], room?.type)
          if (caption) sendTextMessage(caption, null, roomIds[0], room?.type)
        }
        openRoom(roomIds[0])
      } else if (text || link || title) {
        sendTextMessage(text || link || title, null, roomIds[0], room?.type)
        openRoom(roomIds[0])
      }
    },
    1,

    destRoomId =>
      closeForwardList().then(async () => {
        const { sendMessage } = await getRoomPermissions(destRoomId)
        if (!sendMessage) {
          showNoPermissoinToSendMessageSnackbar()
          return
        }
        const room = await getRoom(destRoomId)
        for (const file of files)
          sendNewMessage(file, null, null, destRoomId, room?.type)
        openRoom(destRoomId)
      }),

    true,
  )
}

export function handleSharedTarget() {
  const open = indexedDB.open(SHARED_TARGET_DB_NAME, SHARED_TARGET_DB_VERSION)

  open.onsuccess = () => {
    const db = open.result
    const transaction = db.transaction('shareTargetStore', 'readwrite')
    const store = transaction.objectStore('shareTargetStore')
    const shareTargetQuery = store.get(1)
    shareTargetQuery.onsuccess = () => {
      sendSharedMessage(shareTargetQuery.result.dataToShare)
    }
    store.clear()
    transaction.oncomplete = () => {
      db.close()
    }
  }
}
